import { render, staticRenderFns } from "./DashboardContextHeader.vue?vue&type=template&id=0dae4db4&scoped=true&"
import script from "./DashboardContextHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardContextHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContextHeader.vue?vue&type=style&index=0&id=0dae4db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae4db4",
  null
  
)

export default component.exports